import { render, staticRenderFns } from "./shopping-record.vue?vue&type=template&id=0b8e5675&"
import script from "./shopping-record.vue?vue&type=script&lang=js&"
export * from "./shopping-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports